import { createContext, useContext } from 'react';

// True inside the Edit panel of a Closed KR, where only comments, owner and due date stay editable.
export const ClosedKrLockContext = createContext(false);

export const useClosedKrLock = () => useContext(ClosedKrLockContext);
